import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <AppSection />
        <FeaturesSection />
        <MediaSection />
        <CommentsSection />
        <AboutSection />
        <IndexSection />
        <TopicsSection />
        <CardsSection />
        <ContactSection />
        <UpdatesSection />
        <RankingSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}